import React, { useState } from "react";

//STYLES
import * as ControllerStyles from "../styles/controller";

function GrowWidth(props) {
    const [animWidth, setAnimWidth] = useState(40);

    function handleOnEnter() {
        setAnimWidth(90);
    }

    function handleOnLeave() {
        setAnimWidth(40);
    }

    return (
        <div
            style={{ ...ControllerStyles.menuItem_WidthAnimation, ...props.style, width: `${animWidth}px` }}
            onMouseEnter={handleOnEnter}
            onMouseLeave={handleOnLeave}
        ></div>
    );
}

export default GrowWidth;
